import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { resetAlert } from '@redux/game/gameSlice';
import { MaintainIcon } from '@assets';
import { useTranslation } from 'react-i18next';
import { ModalTopBg } from '@styles';

const Modal = styled(AntModal)`

.ant-modal-title {
    text-align: center;
    color: ${props => props.theme.primaryColor};
    text-transform: capitalize;
}

.ant-modal-content {
    padding-top: 75px !important;
    text-align: center;
}

.ant-modal-footer {
    text-align: center;

    .ant-btn-default {
        display: none !important;
    }
}
`;

const Image = styled(MaintainIcon)`
margin: 0 0 16px 0;
`;

const GameAlert = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { maintain, open, title, description } = useSelector(state => state.game.alert);

    const handleClose = () => {
        dispatch(resetAlert());
    }

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            width={320}
            title={title}
            open={open}
            onCancel={handleClose}
            onOk={handleClose}
            okText={t("common.ok")}
        >
            <ModalTopBg />
            {maintain && <Image />}
            <div>{description}</div>
        </Modal>
    );
}

export default GameAlert;